import { ICurrency } from "../reducers/visitorInfoSlice";
import xhr from "../utils/fetch";
export interface updateUserData {
  email?: string;
  profilePic?: string;
  name?: string;
  phoneNumber?: string;
  preference?: {
    timezone: string;
    currency: ICurrency;
    lessonUpdates: boolean;
    accountUpdates: boolean;
  };
  address?: {
    area: string;
    town: string;
    state: string;
    pincode: string;
    country: string;
  };
  status?: boolean;
}

const addUsers = async (user: any) => {
  return await xhr({
    url: `/u/users`,
    method: "POST",
    body: user
  }).then(res => res.data)
    .catch(err => { throw err })
};

const getUserByEmail = async (email: string) => {
  return await xhr({
    url: `/u/users/${email}`,
    method: "GET",
  }).then(res => res.data)
    .catch(err => { throw err })
};

const updateUser = async (id: string, data: updateUserData) => {
  return await xhr({
    url: `/u/users`,
    method: "PUT",
    body: {
      _id: id,
      data,
    }
  }).then(res => res.data)
    .catch(err => { throw err })
};

const usersApi = {
  addUsers,
  getUserByEmail,
  updateUser,
};

export default usersApi;
